import { Validator } from 'vee-validate'
import moneyIsPositive from './moneyIsPositive'
import moneyIsBiggerThan from './moneyIsBiggerThan'
import moneyIsLessThan from './moneyIsLessThan'

Validator.extend('money_is_positive', moneyIsPositive)
const paramNames = ['min']
Validator.extend('money_is_bigger_than', moneyIsBiggerThan, {
  paramNames
})
Validator.extend('money_is_less_than', moneyIsLessThan, {
  paramNames
})



// WEBPACK FOOTER //
// ./src/customValidators/index.js